export const TRANSPARENT_BACKGROUND = 'TRANSPARENT_BACKGROUND';
